interface IconProps {
  color?: string;
  size?: string | number;
}

const ChevronDownCircleIcon = ({ color = "currentColor", size = 24 }: IconProps) => {
  return (
    <svg height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_11_432)">
        <path d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z" />
        <path
          d="M8.14299 10.965L11.555 14.939C11.6101 15.0031 11.6784 15.0545 11.7552 15.0897C11.832 15.1249 11.9155 15.1432 12 15.1432C12.0845 15.1432 12.168 15.1249 12.2448 15.0897C12.3216 15.0545 12.3899 15.0031 12.445 14.939L15.858 10.965C15.9306 10.88 15.9774 10.7759 15.9927 10.6652C16.008 10.5544 15.9913 10.4416 15.9445 10.34C15.8976 10.2385 15.8227 10.1525 15.7285 10.0922C15.6343 10.032 15.5248 9.99996 15.413 10L8.58699 10C8.47508 9.99973 8.36544 10.0316 8.27114 10.0919C8.17683 10.1521 8.10183 10.2382 8.05505 10.3399C8.00827 10.4416 7.99169 10.5545 8.00728 10.6654C8.02287 10.7762 8.06998 10.8802 8.14299 10.965Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11_432">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChevronDownCircleIcon;
